import React, { Component } from 'react'
import zhihuHybrid from 'zhihu-hybrid'
import ImageArea from '~/components/ImageArea'
import SVG from '~/components/SVG'
// import { isHybridable } from '~/utils'
import playBtn from '~/assets/btn-play.svg'
import styles from './index.css'

export default class Index extends Component {
  state = {
    // isNativePlaySupported: false,
    currentBanner: this.props.headBanner[0],
  }

  componentWillMount() {
    // if (isHybridable) {
    //   zhihuHybrid
    //     .supportsAction('base/openVideo')
    //     .then(isNativePlaySupported => {
    //       this.setState({ isNativePlaySupported })
    //     })
    // }
  }

  handleClick = e => {
    e.preventDefault()
    const { videoId, cover } = this.state.currentBanner
    const { title } = this.props
    zhihuHybrid.dispatch('base/openVideo', { id: videoId, title, cover })
  }

  handleVideoSelect = currentBanner => () => {
    this.setState({ currentBanner })
    const targetEle = document.querySelectorAll(
      `[data-channel="${currentBanner.videoId}"]`
    )[0]
    const wrapElement = document.getElementById('wrap')
    const rectLeft = targetEle.getBoundingClientRect().left
    const centerCoordinate =
      (document.body.clientWidth - targetEle.offsetWidth) / 2
    const diff = rectLeft - centerCoordinate
    this.scrollByRaf(wrapElement, diff)
  }

  scrollByRaf(dom, offset) {
    const frequency = 15
    const step = offset / frequency
    let times = 1
    const move = () => {
      // eslint-disable-next-line no-param-reassign
      dom.scrollLeft += step
      if (times < frequency) {
        // eslint-disable-next-line no-plusplus
        times++
        window.requestAnimationFrame(move)
      }
    }
    window.requestAnimationFrame(move)
  }

  renderVidoeGroup = () => {
    const { currentBanner } = this.state
    const { headBanner } = this.props
    const {
      videoBadge,
      videoItemWrap,
      scrollWrapper,
      bannerVideoGroup,
    } = styles
    return (
      <div className={scrollWrapper}>
        {headBanner.length > 1 && (
          <ul className={bannerVideoGroup} id="wrap">
            {headBanner.map(item => {
              const isCurrentVideo = currentBanner.videoId === item.videoId
              return (
                <li
                  key={`item_${item.videoId}`}
                  className={videoItemWrap}
                  data-channel={item.videoId}
                >
                  <ImageArea
                    src={item.cover}
                    onClick={this.handleVideoSelect(item)}
                    style={{
                      width: 150,
                      height: 73,
                      border: isCurrentVideo && 'solid 3px #0084ff',
                    }}
                  >
                    <div>
                      <SVG
                        src={playBtn}
                        width={30}
                        height={30}
                        style={{
                          visibility:
                            item.bannerType === 0 ? 'visible' : 'hidden',
                        }}
                      />
                      <div className={videoBadge}>
                        {isCurrentVideo ? '当前' : '推荐'}
                      </div>
                    </div>
                  </ImageArea>
                </li>
              )
            })}
          </ul>
        )}
      </div>
    )
  }

  render() {
    const { currentBanner = {} } = this.state
    const { videoSize, title } = this.props
    const { bannerType, cover, videoUrl } = currentBanner
    const { bannerContainer, bannerModule } = styles
    const videoGroupView = this.renderVidoeGroup()
    let bannerView = <ImageArea src={cover} style={videoSize} />
    if (bannerType === 0) {
      // bannerView = isNativePlaySupported ? (
      //   <ImageArea src={cover} style={videoSize}>
      //     <div className={bannerModulePlayButton} onClick={this.handleClick}>
      //       <SVG src={playBtn} width={60} height={60} />
      //     </div>
      //   </ImageArea>
      // ) : (
      //   <div className={bannerModule} style={videoSize}>
      //     <iframe title={title} frameBorder="0" src={videoUrl} />
      //   </div>
      // )
      bannerView = (
        <div className={bannerModule} style={videoSize}>
          <iframe title={title} frameBorder="0" src={videoUrl} />
        </div>
      )
    }

    return (
      <div className={bannerContainer}>
        {bannerView}
        {videoGroupView}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/modules/Banner/index.js